import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { openInstantSaleCheckout } from 'utilities/open-instant-sale-checkout';

export const openPosCheckout = ({ venueCustomerId }: { venueCustomerId: number }) => {
  const isPosEnabled = App.config.get('venue').pointOfSaleEnabled;
  const isNewCheckoutFlowEnabled = Wahanda.Features.isEnabled('TEF-2035-new-checkout-flow');
  const isLiteCheckoutEnabled =
    !isPosEnabled && Wahanda.Features.isEnabled('TEF-4130-lite-checkout');

  const openCheckoutDialog = () => {
    if (isNewCheckoutFlowEnabled) {
      openInstantSaleCheckout({ customerId: venueCustomerId, isLiteCheckoutEnabled });
      return;
    }

    if (isPosEnabled) {
      const dialog = new App.Views.Forms.POSDialog({ venueCustomerId });
      dialog.render();
      dialog.open();
      return;
    }

    const liteDialog = new App.Views.Forms.POSDialogLite();
    liteDialog.render();
    liteDialog.disablePOSSubmit();
    liteDialog.open();
  };

  if (!isPosEnabled) {
    openCheckoutDialog();
    return;
  }

  Wahanda.Cache.posStatus().done((status) => {
    if (!Wahanda.POSCheckoutCheck(status, openCheckoutDialog)) {
      return;
    }
    openCheckoutDialog();
  });
};
